import { Modal, ModalBody, ModalHeader, Card, CardBody, CardTitle, Spinner } from 'reactstrap'
import { IconX } from '@tabler/icons-react'
import { toast } from 'react-toastify'
import { useDelete } from '../../_hooks/useDelete'
import mapper from '../../_endpoints'
import { useFetch } from '../../_hooks/useFetch'
import { usePost } from '../../_hooks/usePost'
import { removeCustomCollection } from '../../_redux/actions/customCollectionsActions'
import { useDispatch } from 'react-redux'
import { Button } from 'dsm-react-lib'
import { StyledModalHeader } from './ContributorModal'

const DeleteCollectionModal = ({
  open,
  onCloseModal,
  onHandleCallback,
  collectionData,
  isCustom
}) => {
  const [isDeleting, deleteCollection] = useDelete()
  const [, deleteSystemCollection] = usePost()
  const [, getCollections] = useFetch()
  const dispatch = useDispatch()

  const handleDelete = async () => {
    try {
      const collectionResponse = await getCollections(mapper.appCollections.get)
      const toDeleteItem = collectionResponse.find((obj) => {
        return obj.collectionName === collectionData.collectionName
      })
      const updatedCollections = collectionResponse.filter((obj) => {
        return obj !== toDeleteItem
      })

      if (isCustom) {
        dispatch(removeCustomCollection(toDeleteItem))
      }

      const url = isCustom
        ? mapper.appCollections.delete.replace(':id', collectionData.collectionId)
        : mapper.collections.deleteSystemCollection.replace(':id', collectionData.collectionId)

      const response = isCustom
        ? await deleteCollection({
            url
          })
        : await deleteSystemCollection({ url })

      if ((response.status === 200 && isCustom) || (response.status === 0 && !isCustom)) {
        toast.success('Collection deleted!')
        onHandleCallback(updatedCollections, toDeleteItem)
      } else {
        toast.error('Error occurred while deleting collection')
        onCloseModal()
      }
    } catch (error) {
      toast.error('Error occurred while deleting collection')
    }
  }

  const onSubmit = () => {
    handleDelete()
  }

  return (
    <Modal
      isOpen={open}
      toggle={onCloseModal}
      className="modal-dialog-centered custom-modal-dialog"
      contentClassName="pt-0">
      <StyledModalHeader
        tag="div"
        toggle={onCloseModal}
        data-testid="closeBtn"
        close={
          <IconX
            size={24}
            color="var(--icon-muted)"
            onClick={onCloseModal}
            className="cursor-pointer"
          />
        }>
        <h5 className="modal-title">
          Delete <strong>{collectionData.collectionName}</strong>
        </h5>
      </StyledModalHeader>
      <ModalBody className="flex-grow-1">
        <Card className="text-center border-0 box-shadow-none">
          <CardBody className="p0">
            <CardTitle tag="h4">
              Do you want to proceed deleting <strong>{collectionData.collectionName}</strong>?
            </CardTitle>
            <span className="text-muted">
              {isCustom
                ? `You will still be able to access these applications once the collection is deleted.`
                : `Users will no longer be able to see this collection. This action does not delete the applications within.`}
            </span>
          </CardBody>
        </Card>
        <div className="d-flex justify-content-end gap-1">
          <Button
            label="Cancel"
            variant="outline"
            color="neutral"
            className="dsm-btn-neutral"
            onClick={onCloseModal}
            data-testid="cancelBtn"
          />
          <Button
            color="danger"
            disabled={isDeleting}
            onClick={onSubmit}
            label={
              isDeleting ? (
                <>
                  Deleting...
                  <Spinner />
                </>
              ) : (
                'Delete'
              )
            }
            data-testid="deleteCollection"></Button>
        </div>
      </ModalBody>
    </Modal>
  )
}
export default DeleteCollectionModal
